export default "__VITE_ASSET__4c0ea712__"